/**
 * @desc hello
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/`, {
      method: "OPTIONS",

      ...options,
    }),
  );
}
